import React from "react";
import { Section } from "../Section";
import { DOCTOR_URL } from "../../data/landing";
export function AboutSection() {
  return <Section tone="sand" narrow cta="I want to learn from every case" data-id="element-63" data-mp="chhxbb82gkqs">
      <div className="text-center" data-id="element-64" data-mp="hft5zimmkp7f">
        <img src={DOCTOR_URL} alt="Dr. Michael Carter" className="mx-auto h-32 w-32 rounded-full object-cover object-top ring-4 ring-white shadow-lg" data-id="element-65" data-mp="herlknjpyqd1" />
        <p className="mt-5 text-xs font-bold uppercase tracking-[0.18em] text-rose" data-id="element-66" data-mp="qg7uequvykf5">About Dr. Michael Carter</p>
        <h2 className="mt-2 font-serif text-[30px] font-bold leading-tight text-ink md:text-4xl" data-id="element-67" data-mp="vdzj7c08hqf4">
          Creator of the Breast Augmentation Clinical Pathway™
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-2xl space-y-4 text-[17px] leading-relaxed text-inkSoft" data-id="element-68" data-mp="155422mt15vf8">
        <p data-id="element-69" data-mp="198tp37u244y5">
          I'm Dr. Michael Carter. I created the Breast Augmentation Clinical Pathway™ because I kept seeing the same
          problem in professional case discussions.
        </p>
        <p data-id="element-70" data-mp="1dn72k7y8hhl3">
          There is no shortage of information. There are courses, conferences, surgical demonstrations, papers and
          textbooks. But having access to more information doesn't automatically give you a better process for
          organizing that information when you're looking at a new case.
        </p>
        <p className="font-semibold text-ink" data-id="element-71" data-mp="zoquodomxl1d">That's what I wanted to address.</p>
        <p data-id="element-72" data-mp="1x9v9xk39lizx">
          I didn't want to create another textbook. And I didn't want to create another 20-hour course. I wanted to
          build something practical — a structured system that you could open when you have an educational case in
          front of you.
        </p>
        <div className="grid gap-2 rounded-2xl bg-white p-5 text-[16px] font-medium text-ink sm:grid-cols-2" data-id="element-73" data-mp="1ikgze8nycviy">
          {["A way to slow down.", "Observe before concluding.", "Identify information gaps.", "Ask better questions.", "Prioritize what deserves further review.", "Extract a lesson from every case."].map(l => <p key={l} className="flex gap-2.5" data-id="element-74" data-mp="dcxmtx3xc317">
              <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-rose" aria-hidden="true" data-id="element-75" data-mp="3vsgi0a6iedk5" />
              {l}
            </p>)}
        </div>
        <p className="text-[15px]" data-id="element-76" data-mp="4k2ntl51v3jv">
          It's not designed to replace formal surgical training, mentorship, current clinical guidelines or professional
          judgment. It's an educational framework designed to help you practice structured case analysis.
        </p>
        <p className="font-semibold text-ink" data-id="element-77" data-mp="3cudyuc0n7au9">If that is something you've been looking for, I created this system for you.</p>
        <p className="font-serif text-xl font-bold italic text-ink" data-id="element-78" data-mp="3hsp7ijf7bfaw">— Dr. Michael Carter</p>
      </div>
    </Section>;
}